import type { FormInstance } from 'element-plus'
import { spaI18n } from '@/compositions/i18nPlugin'

const RE_LOWERCASE = /[a-z]/
const RE_UPPERCASE = /[A-Z]/
const RE_DIGIT = /\d/
const RE_SPECIAL_CHAR = /[^a-z0-9\s]/i

function checkNumberValidator() {}
function mustBeValueValidator(value: any): (_rule: unknown, fieldValue: any) => boolean {
  return (_rule: unknown, fieldValue: any) => {
    return value === fieldValue
  }
}
function passwordValidator() {
  return {
    validator: (_rule: unknown, value: string) => {
      const t = spaI18n.global.t
      if (!value?.length) {
        return Promise.reject(new Error(t('common.required')))
      }
      const errorMsg: string[] = []
      if (value.length < 6) {
        errorMsg.push(t('validators.char6'))
      }
      if (!RE_LOWERCASE.test(value)) {
        errorMsg.push(t('validators.lowercase'))
      }
      if (!RE_UPPERCASE.test(value)) {
        errorMsg.push(t('validators.uppercase'))
      }
      if (!RE_DIGIT.test(value)) {
        errorMsg.push(t('validators.number'))
      }
      if (!RE_SPECIAL_CHAR.test(value)) {
        errorMsg.push(t('validators.specialChar'))
      }
      if (errorMsg.length > 0) {
        return Promise.reject(new Error(`${t('validators.mustContainPrefix')} ${errorMsg.join(', ')}`))
      }
      return Promise.resolve()
    },
    trigger: 'change'
  }
}
function confirmPasswordValidator(form: Record<string, any>, passwordFieldName = 'password') {
  return {
    validator: (_rule: unknown, value: string) => {
      const t = spaI18n.global.t
      if (!value?.length) {
        return Promise.reject(new Error(t('common.required')))
      }
      if (value !== form[passwordFieldName]) {
        return Promise.reject(new Error(t('validators.passwordsNoMatch')))
      }
      return Promise.resolve()
    },
    trigger: 'change'
  }
}
function onChangePassword(form: Record<string, any>, formInstance: FormInstance | undefined, confirmPasswordFieldName = 'confirmPassword'): void {
  if (form?.[confirmPasswordFieldName]?.length) {
    formInstance?.validateField(confirmPasswordFieldName).catch(() => {})
  }
}
export {
  checkNumberValidator,
  confirmPasswordValidator,
  mustBeValueValidator,
  onChangePassword,
  passwordValidator
}
